/*
 * @Author: shisan
 * @Date: 2019-07-11 18:01:55
 * @Last Modified by: shisan
 * @Last Modified time: 2020-03-19 09:43:18
 */
import jsonp from './jsonp'
import appPrince from './callApp'
import mgHttp from '../request/request'
/**
 * 加载制定路径的一组图片
 * @param {*} param0
 */
export async function loadImages({
  path,
  frames,
  context,
  callback,
  serverPath = 'https://app.mgtv.com/MangoKid',
}) {
  let count = 0
  let retImg = []
  return new Promise((resolve, reject) => {
    for (let i = 0; i < frames; i++) {
      const img = new Image()

      img.onload = () => {
        count++
        img.onload = null
        retImg[i] = img

        if (count === frames) {
          typeof callback === 'function' && callback(retImg)
          resolve(retImg)
        }
      }
      img.onerror = () => {
        console.log('图片加载失败', img.src)
        context.$toast('O__O "…好像出了点问题', () => {
          location.reload()
        })
      }
      img.src = `${serverPath}/${path}${i}.png`
    }
  })
}

/**
 * 序列帧动画
 */
export function startAnimate({ dom, data, loop, callback, isPlay = true }) {
  data.actualWidth =
    document.documentElement.clientWidth * (data.designWidth / data.viewWidth)
  data.actualHeight = (data.actualWidth * data.designHeight) / data.designWidth

  data.keyFramesHandler = new CanvasKeyFrames(dom, 'array', data.imgArr, {
    width: data.designWidth,
    height: data.designHeight,
    viewWidth: data.viewWidth,
    loop,
  })

  if (!isPlay) return
  data.keyFramesHandler.play(() => {
    callback && callback()
  })
}

/**
 * 判断是iphonex以上机型
 */
// eslint-disable-next-line complexity
export function isIphoneXRS() {
  const UA = window.navigator.userAgent
  const devicePixelRatio = window.devicePixelRatio
  return (
    (/iphone/gi.test(UA) &&
      devicePixelRatio &&
      devicePixelRatio === 3 &&
      window.screen.width === 375 &&
      window.screen.height === 812) ||
    (/iphone/gi.test(UA) &&
      devicePixelRatio &&
      devicePixelRatio === 3 &&
      window.screen.width === 414 &&
      window.screen.height === 896) ||
    (/iphone/gi.test(UA) &&
      devicePixelRatio &&
      devicePixelRatio === 2 &&
      window.screen.width === 414 &&
      window.screen.height === 896)
  )
}

export function isIphone() {
  return /iphone/.test(navigator.userAgent.toLowerCase())
}

export function isAphone() {
  return /android/.test(navigator.userAgent.toLowerCase())
}

export function isIpad() {
  return /ipad/.test(navigator.userAgent.toLowerCase())
}

export function isWechat() {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

export function isQQ() {
  return /qq/.test(navigator.userAgent.toLowerCase())
}

/**
 * 是否在APP内
 */
export function isInApp() {
  return /imgo/.test(navigator.userAgent.toLowerCase())
}

/**
 * 上报布码
 */
export async function setMgStat({ G, D, s, c, p }) {
  let timer = null
  return new Promise((resolve, reject) => {
    c = {
      site_version: 'v1.2', //【必填】 业务方版本号
      server_url: '//pcweb-v1.log.mgtv.com/dispatcher.do', //【可选】由大数据部门下发的上报地址
      sdk: '//honey.mgtv.com/honey-2.0/lib/mba.min.js', //【必填】SDK文件托管地址
      enable: {
        show: true,
      },
    }
    G.MgStat
      ? G.MgStat.config(c, p)
      : (G.MgStatTQ = G.MgStatTQ || []).push([c, p]),
      !G._mbaLoading && load()

    timer = setInterval(() => {
      if (G.MgStat) {
        clearInterval(timer)
        timer = null
        resolve()
      }
    }, 20)

    function load(t) {
      G._mbaLoading = 1
      s = D.createElement('script')
      s.src = c.sdk
      t = D.getElementsByTagName('script')
      t = t[t.length - 1]
      t.parentNode.insertBefore(s, t)
    }
  })
}

/**
 * 格式化秒数
 * @param {*} n
 */
export function formatSecond(n) {
  if (n >= 1 * 60 * 60) {
    return Math.ceil(n / 3600) + '小时'
  } else {
    return Math.ceil(n / 60) + '分钟'
  }
}

export function zeroFill(n) {
  return parseInt(n) < 10 ? '0' + n : n
}

export function getMS(seconds) {
  var min = zeroFill(Math.floor(seconds / 60) % 60)
  var sec = zeroFill(seconds % 60)

  return min + ':' + sec
}

export function getHM(seconds) {
  var hour = zeroFill(Math.floor(seconds / 60 / 60))
  var min = zeroFill(Math.floor(seconds / 60) % 60)

  return hour + ':' + min
}

export function getRandomArrayElements(arr, count) {
  var shuffled = arr.slice(0),
    i = arr.length,
    min = i - count,
    temp,
    index
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random())
    temp = shuffled[index]
    shuffled[index] = shuffled[i]
    shuffled[i] = temp
  }
  return shuffled.slice(min)
}

export function clickReport({
  type = 'click',
  cont,
  cntp = 'user_mgSonHome',
  lobObj,
}) {
  MgStat.send(type, lobObj, { cont })
}

// 跳转
export function jumpPage(url) {
  let ua = navigator.userAgent.toLowerCase()
  let paramsInherit = getParamsInherit(url)
  if (location.href.indexOf('app.mgtv.com') == -1) {
    url = url.replace('https://app.mgtv.com/crazy-wendnesday', location.origin)
  }
  if (/imgo/.test(ua) && url.indexOf('imgotv://') == -1) {
    console.log('imgo', url + paramsInherit)
    MgtvApi.jumpPage({ url: url + paramsInherit, disableEncode: '1' })
  } else {
    setTimeout(() => {
      window.location = url + paramsInherit
    }, 300)
  }
}

//获取当前页面需要继承的参数并返回
export function getParamsInherit(url) {
  let paramsNeed = ['is_preview']
  let paramsNeedArr = []
  let paramsNeedStr = ''
  let targetUrl = new URL(url) //目的页面对象
  let currentUrl = new URL(location.href) //当前页面对象

  paramsNeed.forEach(item => {
    let currentValue = parseQuery()[item]
    if (
      currentValue != undefined &&
      currentValue != '' &&
      currentValue != 'undefined'
    ) {
      paramsNeedArr.push(item + '=' + currentValue)
    }
  })

  paramsNeedStr = paramsNeedArr.join('&')
  //如果有search了则去掉当前页面?后拼接
  if (targetUrl.search && currentUrl.search) {
    return '&' + paramsNeedStr
  } else if (!targetUrl.search && currentUrl.search) {
    //如果目标页面没有search但是当前页面有则直接拼接
    return '?' + paramsNeedStr
  } else {
    return ''
  }
}

export function parseQuery(link) {
  let url = link ? link : location.href
  let theRequest = {}

  if (url.indexOf('?') != -1) {
    let str = url.substr(url.indexOf('?') + 1)
    let strs = str.split('&')

    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}

// 监听页面是否显示（如手机锁屏、打开新webview后返回）
export function monitorPageVisibility(callBack) {
  var visProp = getHiddenProp()
  if (visProp) {
    var evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange'
    window.pageReshowCallback = callBack
    document.addEventListener(evtname, minitorCallBack, false)
  }
}

//判断页面隐藏
export function getHiddenProp() {
  let prefixes = ['webkit', 'moz', 'ms', 'o']

  if ('hidden' in document) return 'hidden'

  for (let i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'Hidden' in document) return prefixes[i] + 'Hidden'
  }
  return null
}

//监听事件的回调
function minitorCallBack() {
  if (document.visibilityState == 'visible' || !document.hidden) {
    //防止回到首页加载问题
    setTimeout(() => {
      window.pageReshowCallback && window.pageReshowCallback()
    }, 500)
  }
}

//按照key ascii排序并排列
export function sortASCIIandStringfy(obj) {
  let arr = new Array()
  let num = 0
  let stringifyStr = ''
  for (let i in obj) {
    arr[num] = i
    num++
  }
  let sortArr = arr.sort()
  let sortObj = {}
  for (let i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]]
  }
  for (let i in sortObj) {
    stringifyStr = `${stringifyStr}${i}=${sortObj[i]}&`
  }
  return stringifyStr
}

// 随机字符串
export function randomString() {
  let sourceChars =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let stringLength = 32
  let result = ''
  for (let i = stringLength; i > 0; --i)
    result += sourceChars[Math.floor(Math.random() * sourceChars.length)]
  return result
}

export function toParam(obj) {
  let result = []
  for (let key in obj) {
    result.push(key + '=' + obj[key])
  }
  return result.join('&')
}

// 打开芒果tv或者下载
export function downloadMGTV(callURL) {
  var jumpSchema
  var ua = navigator.userAgent.toLowerCase()
  var isWechat = /micromessenger/.test(ua)
  var isAndroid = /android/.test(ua)
  var isQQ = /qq/.test(ua)
  var entrance = parseQuery().entrance || ''

  jumpSchema =
    'imgotv://webview?from=hitv&url=' +
    encodeURIComponent(callURL || location.href)

  if (isWechat || isQQ) {
    location.href =
      'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1435603257834&ios_scheme=' +
      encodeURIComponent(jumpSchema) +
      '&android_schema=' +
      encodeURIComponent(jumpSchema)
    // location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=' + encodeURIComponent(jumpSchema) + '&android_schema=' + encodeURIComponent(jumpSchema);
  } else {
    if (isAndroid) {
      var ifr = document.createElement('iframe')
      ifr.src = jumpSchema
      ifr.style.display = 'none'
      document.body.appendChild(ifr)

      var t = Date.now()
      timer = setTimeout(function () {
        if (Date.now() - t > 2400) {
          clearTimeout(timer)
          return false
        }
        if (document.webkitHidden || document.hidden) {
          return false
        }
        location.href = 'https://mobile.api.mgtv.com/thridGetApk?code=c103001'
        // location.href = 'https://mobile.api.mgtv.com/thridGetApk?code=nbhd02';
      }, 2000)
    } else {
      location.href = jumpSchema

      setTimeout(function () {
        // location.href = 'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=10sec&mt=8';
        location.href =
          'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=c103001&mt=8'
      }, 3000)
    }
  }
}

// 获取当前年月日
export function getYMD(dateVar) {
  let date = dateVar || new Date()
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()

  return zeroFill(year) + '-' + zeroFill(month) + '-' + zeroFill(day)
}

//微信分享信息设置
export function setShareInfo(params, callback) {
  if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
    console.log('in wechat')

    // 设置微信分享
    // $.ajax({
    //     url: 'https://vs.api.mgtv.com/weixin/sign',
    //     type: 'get',
    //     dataType: 'jsonp',
    //     data: {
    //         url: location.href.split('#')[0]
    //     },
    //     timeout: 10000
    // })
    shareJSONP1().then(resp => {
      wx.config({
        debug: false,
        appId: resp.appId,
        timestamp: resp.timestamp,
        nonceStr: resp.nonceStr,
        signature: resp.signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareQZone',
        ],
      })

      wx.ready(function () {
        // 分享到朋友圈
        wx.onMenuShareTimeline({
          type: 'link',
          title: params.title,
          link: params.url,
          imgUrl: params.pic,
          success: function () {
            if (typeof callback === 'function') callback()
          },
          cancel: function () { },
        })

        // 分享给朋友
        wx.onMenuShareAppMessage({
          type: 'link',
          title: params.title,
          desc: params.desc,
          link: params.url,
          imgUrl: params.pic,
          success: function () {
            if (typeof callback === 'function') callback()
          },
          cancel: function () { },
        })

        wx.onMenuShareQQ({
          title: params.title, // 分享标题
          desc: params.desc, // 分享描述
          link: params.url, // 分享链接
          imgUrl: params.pic, // 分享图标
          success: function () {
            if (typeof callback === 'function') callback()
          },
          cancel: function () { },
        })

        wx.onMenuShareQZone({
          title: params.title, // 分享标题
          desc: params.desc, // 分享描述
          link: params.url, // 分享链接
          imgUrl: params.pic, // 分享图标
          success: function () {
            if (typeof callback === 'function') callback()
          },
          cancel: function () { },
        })
      })
    })
  } else if (/qq/.test(navigator.userAgent.toLowerCase())) {
    console.log('in qq')

    // 设置QQ分享
    setShareInfo({
      title: params.title,
      summary: params.desc,
      url: params.url || location.href,
      pic: params.pic || 'http://i2.hitv.com/p1/20180502/1513461816.png',
    })
  }
}

/**
 * 设置分享
 */
function shareJSONP1() {
  return jsonp('https://vs.api.mgtv.com/weixin/sign', {
    url: location.href.split('#')[0],
  })
}

// eslint-disable-next-line max-params
export function throttle(func, wait, options, cxt) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true;
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  let context, args, result
  let timeout = null
  let previous = 0
  if (!options) options = {}
  const later = function () {
    previous = options.leading === false ? 0 : new Date().getTime() - 0
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  wait = wait || 0
  return function () {
    const now = new Date().getTime()
    if (!previous && options.leading === false) previous = now
    // 计算剩余时间
    const remaining = wait - (now - previous)
    if (cxt) {
      context = cxt
    } else {
      context = this
    }

    args = arguments
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export function getYMDHMS() {
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hour = date.getHours()
  var min = date.getMinutes()
  var sec = date.getSeconds()

  return (
    '' +
    zeroFill(year) +
    zeroFill(month) +
    zeroFill(day) +
    zeroFill(hour) +
    zeroFill(min) +
    zeroFill(sec)
  )
}

export function uuid4() {
  let r = Math.random,
    p = '0000000',
    n = 0x100000000,
    a = ((r() * n) >>> 0).toString(16),
    b = ((((r() * n) & 0xffff4fff) | 0x4000) >>> 0).toString(16),
    c = ((((r() * n) & 0xbfffffff) | 0x80000000) >>> 0).toString(16),
    d = ((r() * n) >>> 0).toString(16)
  if (a.length < 8) {
    a = (p + a).slice(-8)
  }
  if (b.length < 8) {
    b = (p + b).slice(-8)
  }
  if (c.length < 8) {
    c = (p + c).slice(-8)
  }
  if (d.length < 8) {
    d = (p + d).slice(-8)
  }
  return [a, b.slice(0, 4), b.slice(4), c.slice(0, 4), c.slice(4) + d].join('-')
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string' && typeof content !== 'number') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}
/**
 * 获取localStorage
 */
export const getStore = name => {
  const val = window.localStorage.getItem(name)
  try {
    return JSON.parse(val)
  } catch (error) {
    return val
  }
}
/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

//获取滚动条当前的位置
export function getScrollTop() {
  let scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}

//获取当前可是范围的高度
export function getClientHeight() {
  let clientHeight = 0
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = Math.min(
      document.body.clientHeight,
      document.documentElement.clientHeight
    )
  } else {
    clientHeight = Math.max(
      document.body.clientHeight,
      document.documentElement.clientHeight
    )
  }
  return clientHeight
}

//获取文档完整的高度
export function getScrollHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight
  )
}

export function callApp(callURL) {
  // this.checkWeibo()
  let jumpSchema =
    'imgotv://webview?from=hitv&url=' +
    encodeURIComponent(callURL || location.href)
  appPrince.kiss({
    schemaUrl: jumpSchema,
    tencentUrl:
      'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1449084199069&ios_scheme=' +
      encodeURIComponent(jumpSchema) +
      '&android_schema=' +
      encodeURIComponent(jumpSchema),
    itunesUrl:
      'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=mg12&mt=8',
    andriodUrl: 'https://mobile.api.mgtv.com/thridGetApk?code=c103801',
  })
}

/**
 * 计算距离当前day天的日期
 * @param {*} day
 */
export function getLeftYMD(day) {
  if (!day || day < 1) return getYMD()
  const now = Date.now()
  const calcDate = new Date(now - day * 24 * 60 * 60 * 1000)
  return getYMD(calcDate)
}

/**
 * 时间戳（当前年月日+时间）
 */
export function getTimeStamp(time) {
  time = getYMD().replace(/\-/gi, '/') + ' ' + time
  return new Date(time).getTime();
}

/**
 * 获取好物url
 */
export function getHaoWuUrl(id, type, lastp) {
  // 测试 shoptest  线上 shop
  let link =
    'https://lingxi.mgtv.com/shop/index.html#/goods/detail?id=' +
    id +
    '&lastp=' +
    lastp +
    '&from=jifen_shop_home'
  if (type) {
    return link + '&flash_day=' + type + '&t=' +
      new Date().getTime()
  } else {
    return link + '&t=' +
      new Date().getTime()
  }
}

/**
 * 计算两个日期之间相差的天数
 * startDate和endDate是2006/12/18格式(ios兼容)
 */
export function dateDiff(startDate, endDate) {
  var startTime = new Date(Date.parse(startDate)).getTime();
  var endTime = new Date(Date.parse(endDate)).getTime();
  return Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24);
}

export function isVersionBigger(appVerOrigin, targetVerOrigin = '8.3.3') {
  if (!appVerOrigin) {
    return false
  }
  const appVer = appVerOrigin.split('_')[0].split('.')
  const targetVer = targetVerOrigin.split('.')
  let currentVersion = appVer[0] + appVer[1] + appVer[2]
  let targetVersion = targetVer[0] + targetVer[1] + targetVer[2]
  currentVersion = Number(currentVersion)
  targetVersion = Number(targetVersion)
  console.log(currentVersion, 'currentVersion')
  return currentVersion >= targetVersion
}

export function setNewWXShareInfo(params, callback) {
  const ua = navigator.userAgent.toLowerCase()
  const isWeChat = /micromessenger/.test(ua)
  const isQQ = /qq/.test(ua)

  if (isWeChat) {
    // 设置微信分享
    mgHttp({
      method: 'get',
      url: 'https://oauth.mgtv.com/weixin/sign',
      params: {
        url: location.href,
        appname: 'mgfs',
        uid: '',
      },
    }).then((resp) => {
      if (resp.status === 200) {
        wx.config({
          debug: false,
          appId: resp.data.appId,
          timestamp: resp.data.timestamp,
          nonceStr: resp.data.nonceStr,
          signature: resp.data.signature,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone',
          ],
          openTagList: ['wx-open-launch-app'],
        })
        wx.ready(function () {
          const paramsObject = {
            type: 'link',
            title: params.title,
            desc: params.desc,
            link: params.shareUrl,
            imgUrl: params.shareIcon,
            success() {
              callback && callback()
            },
          }
          wx.onMenuShareTimeline(paramsObject)
          wx.onMenuShareAppMessage(paramsObject)
          wx.onMenuShareQQ(paramsObject)
          wx.onMenuShareQZone(paramsObject)
        })
      }
    })
  } else if(isQQ){
    // 设置QQ分享
    const shareInfoQQ = {
      title: params.title,
      summary: params.desc,
      desc: params.desc,
      url: params.shareUrl || location.href,
      share_url: encodeURI( params.shareUrl || location.href),
      pic: params.shareIcon,
      image_url:  params.shareIcon,
    }
    console.log(shareInfoQQ)
    console.log('window.setShareInfo', window.setShareInfo)
    if(window.setShareInfo){
      window.setShareInfo(shareInfoQQ)
      window.mqq && window.mqq.data.setShareInfo(shareInfoQQ);
    } else {
      setTimeout(() => {
        window.setShareInfo(shareInfoQQ)
        window.mqq && window.mqq.data.setShareInfo(shareInfoQQ);
    }, 2000);
    }
  }
}
